import script from "./Ticketing.vue?vue&type=script&setup=true&lang=js"
export * from "./Ticketing.vue?vue&type=script&setup=true&lang=js"

import "./Ticketing.vue?vue&type=style&index=0&id=329006d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329006d6"]])

export default __exports__